<template>
  <button
   class="button pa-prev-button"
   :class="additionalClass"
   :disabled="isDisabled"
   
   @click.prevent="handleClick"
  >過去を取得</button>
</template>

<script>
export default {
  props : {
    isLoading : {
      default : false
    }
  },

  data(){
    return {
      additionalClass : {
        'is-loading'  : false
      },
      
      isDisabled      : false,
    };
  },

  watch : {
    isLoading : {
      handler(value){
        if(value === true){
          this.isDisabled = true;
          this.additionalClass['is-loading'] = true;
        }else{
          this.isDisabled = false;
          this.additionalClass['is-loading'] = false;
        }
      },
      immediate: true
    }
  },

  methods : {
    handleClick(){
      this.$emit('handleClick');
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-prev-button{
  display:block;
  width:96%;
  margin:0rem auto .5rem;
  border:2px solid #C6AB89;
  background-color: #C4A989;
  color: #736154;
  padding:0;

  &:hover, &:active{
    color: #736154;
    background-color: #C4A989;
    border:2px solid #C6AB89;
  }

  &:focus{
    box-shadow:none;
  }

  &.is-loading{
    background-color: #B9916F;
    border-color: #B58A68;
  }

  &.is-loading::after{
    border: 1.3px solid #6C482B;
    border-right-color: transparent;
    border-top-color: transparent;
  }

  @include until($tablet) {
    display: none;
  }
}
</style>